import { Utilities, type Settings } from 'core/domains';

import { staticRoutes } from './static-routes';

export const initialState = {
  data: {
    featureToggle: {
      creditCardForm: true,
      shippingModel: true,
      buyIntention: true,
    },
    routes: staticRoutes,
  },
  message: '',
  status: Utilities.STATUS.IDLE,
  updatedAt: 0,
} as Settings;
